import { useController } from 'react-hook-form'

import { Autocomplete, TextField } from '@mui/material'

const AutocompleteControlled = (props) => {
  const { label, name, control, rules, options = [], ...rest } = props

  const { field, fieldState: { error } } = useController({ name, control, rules })

  return (
    <Autocomplete
      name={name}
      onChange={(_, data) => field.onChange({ id: data.id, name: data.name })}
      options={options}
      noOptionsText={"No hay registros"}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.name || ''}
      renderInput={(params) => (
        <TextField
          label={label}
          variant="standard"
          error={!!error}
          helperText={error?.message}
          {...params}
        />
      )}
      {...rest}
    />
  )
}

export default AutocompleteControlled
